// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4610b677dba54c1a3c360366606950356189858b/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};